import { socketService } from '@aqx-core/common/socket';
import { IPriceLadderTopicMessage } from '@aqx-core/common/socket/topics/price-ladder';

class PriceLadderTopicSubscription {
  public subscribe = (
    symbol: string,
    subscriptionKey: string,
    updatePriceLadderData: (payload: IPriceLadderTopicMessage | undefined) => void
  ) => {
    socketService.topics().priceLadder.subscribe({
      symbol: symbol,
      receiver: {
        subscriptionKey,
        payload: (payload) => updatePriceLadderData(payload)
      }
    });
  };

  public unsubscribe = (
    symbol: string,
    subscriptionKey: string,
    updatePriceLadderData: (payload: IPriceLadderTopicMessage | undefined) => void
  ) => {
    socketService.topics().priceLadder.unsubscribe({
      symbol: symbol,
      receiver: {
        subscriptionKey,
        payload: (payload) => updatePriceLadderData(payload)
      }
    });
  };
}

export const priceLadderTopicSubscription = new PriceLadderTopicSubscription();
